import type { FlowGraph } from '../FlowGraph';
import type { NodeId, ComparisonMode } from 'web';

export class ComparisonView {
  constructor(
    private graph: FlowGraph,
    private nodeId: NodeId,
  ) {}

  setMode(mode: ComparisonMode) {
    this.graph.wasmChange((wasm) => wasm.setComparisonMode(this.nodeId, mode));
  }
}
